import classNames from "classnames";
import { buildHidePopoverIfAlreadyShowing, ButtonWithPopover, defaultAnimationWithHidingSmooth } from "Components/button";
import React, { memo, useCallback, useEffect, useMemo, useRef, useState } from "react";
import { v4 as uuid } from "uuid";
import Panel from "./panel";
const menuPosition = {
    my: "top right",
    at: "bottom right",
    collision: "fit flip",
    offset: { y: 2 }
};
const SIZES = {
    BUTTON_HEIGHT: 24,
    POPOVER_DEFAULT_WIDTH: 300,
    POPOVER_WITH_CUSTOM_FORM_DEFAULT_WIDTH: 325,
    POPOVER_DEFAULT_HEIGHT: 350,
    POPOVER_WITH_CUSTOM_FORM_DEFAULT_HEIGHT: 420
};
function AddToSummaryReport(props) {
    var _a;
    const popoverRef = useRef(null);
    const btnId = useMemo(() => `addToSummaryReportBtn_${uuid()}`, []);
    const handleHideIfAlreadyShowing = useCallback(buildHidePopoverIfAlreadyShowing(popoverRef), []);
    const [popoverContent, setPopoverContent] = useState(React.createElement("div", null));
    useEffect(() => {
        var _a;
        if ((_a = document.getElementById(btnId)) === null || _a === void 0 ? void 0 : _a.classList.contains("active")) {
            setPopoverContent(prev => React.cloneElement(prev, {
                data: props.data,
                getValue: props.getValue,
                customForm: props.customForm
            }));
        }
    }, [props.data, props.getValue, props.customForm]);
    const handleShowing = useCallback(() => {
        var _a;
        setPopoverContent(React.createElement(Panel, { key: uuid(), data: props.data, getValue: props.getValue, projectId: props.projectId, onHide: handleHideIfAlreadyShowing, className: "unselectable", mainFormClassName: props.mainFormClassName, customForm: props.customForm }));
        (_a = document.getElementById(btnId)) === null || _a === void 0 ? void 0 : _a.classList.add("active");
        props.onShowing && props.onShowing();
    }, [
        props.data,
        props.getValue,
        props.projectId,
        handleHideIfAlreadyShowing,
        props.customForm,
        btnId,
        props.onShowing,
        props.mainFormClassName
    ]);
    const handleHiding = useCallback(() => {
        var _a;
        (_a = document.getElementById(btnId)) === null || _a === void 0 ? void 0 : _a.classList.remove("active");
        props.onHiding && props.onHiding();
    }, [btnId, props.onHiding]);
    return ((_a = props.data) === null || _a === void 0 ? void 0 : _a.DocumentId) ? (React.createElement(ButtonWithPopover, { className: classNames("no-border btn-filled pt-0 pb-0", props.className), buttonHeight: 32, buttonWidth: 32, showEvent: "dxclick", animation: defaultAnimationWithHidingSmooth, height: props.height, position: menuPosition, popoverRef: popoverRef, popoverWidth: props.popoverWidth ||
            (props.customForm
                ? SIZES.POPOVER_WITH_CUSTOM_FORM_DEFAULT_WIDTH
                : SIZES.POPOVER_DEFAULT_WIDTH), popoverHeight: props.popoverHeight ||
            (props.customForm
                ? SIZES.POPOVER_WITH_CUSTOM_FORM_DEFAULT_HEIGHT
                : SIZES.POPOVER_DEFAULT_HEIGHT), onClick: handleHideIfAlreadyShowing, ignoreHidingWhenChanged: true, popoverContent: popoverContent, onShowing: handleShowing, onHiding: handleHiding, id: btnId, disabled: props.disabled },
        React.createElement("i", { className: "icon-add-to-summary" }))) : null;
}
export default memo(AddToSummaryReport);
